import React, { ReactElement } from 'react';
import { useTheme } from 'styled-components';
import type { IconType, IconProps, SvgIconProps } from './types';
import Accessibility from './icons/Accessibility';
import Accessibility2 from './icons/Accessibility2';
import Accessibility3 from './icons/Accessibility3';
import Adult from './icons/Adult';
import Education from './icons/Education';
import Family from './icons/Family';
import Member from './icons/Member';
import Member2 from './icons/Member2';
import Zsl200 from './icons/Zsl200';
import CalendarCheck from './icons/CalendarCheck';
import Calendar from './icons/Calendar';
import Location from './icons/Location';
import Clock from './icons/Clock';
import Ticket from './icons/Ticket';

export type { IconType, IconProps } from './types';
export { ICON_TYPES } from './types';

const ICON_MAP: Record<IconType, React.ComponentType<SvgIconProps>> = {
  accessibility: Accessibility,
  'accessibility-2': Accessibility2,
  'accessibility-3': Accessibility3,
  family: Family,
  adult: Adult,
  education: Education,
  member: Member,
  'member-2': Member2,
  'zsl-200': Zsl200,
  'calendar-check': CalendarCheck,
  calendar: Calendar,
  location: Location,
  clock: Clock,
  ticket: Ticket,
};

export default function Icon({
  type,
  color,
  useCurrentColor = false,
  height = 50,
  width = 50,
  className,
  ariaHidden,
  ariaLabel,
}: IconProps): ReactElement | null {
  const theme = useTheme();
  const fill = useCurrentColor ? 'currentColor' : (color ?? theme.colors.primary);
  const Component = ICON_MAP[type];

  if (!Component) return null;

  return (
    <Component
      fill={fill}
      width={width}
      height={height}
      className={className}
      ariaLabel={ariaLabel}
      ariaHidden={ariaHidden}
    />
  );
}
